import { ReactNode } from 'react';
import { BoxProps } from 'styled-system/jsx';

export type WalletLayoutPropTypes = {
  children: React.ReactNode;
};

export enum Months {
  فروردین = 1,
  اردیبهشت,
  خرداد,
  تیر,
  مرداد,
  شهریور,
  مهر,
  آبان,
  آذر,
  دی,
  بهمن,
  اسفند,
}

export type TWalletProps = {
  children: ReactNode;
  wrapperProps?: BoxProps;
  className?: string;
};

export type TPeriodicItems = {
  id: string;
  month: string;
  year: string;
  isDisabled: boolean;
};

export type TMonthReportInfo = {
  total_amount: number;
  unpaid: number;
  paid: number;
  files_count: number;
  fa_name: string;
};
